module.exports = __webpack_public_path__ + "assets/img/img25.e169eaf1.png";